import React, { useEffect, useState } from 'react';
import CustomDataGrid from '../../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Dialog,
  capitalize,
  Switch
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import { Icon } from '@iconify/react';
import nodata from '../../../../../../app/assets/images/nodata.png.png';
import CustomBreadcrumbs from '../../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import constant from '../../../../../../utils/constants';
import UpdatePVTGRP from '../UpdatePvtGrp';
import {
  capitalizeFirstLetter,
  convertTo12HourFormat
} from '../../../../../../utils/commonFunctions';
import * as yup from 'yup';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import {
  autoGeneratedTripsAction,
  clearPVTandGRP,
  driverDropdownAction,
  getScheduleDriverAction
} from '../../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import { GridActionsCellItem } from '@mui/x-data-grid';

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
}

interface Props {
  scheduleDate: number;
  agent: any;
  vehicle: any;
  setPayload: any;
}

interface PaginationModel {
  page: number;
  pageSize: number;
}

const ScheduledPvt = ({ scheduleDate, agent, vehicle, setPayload }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [view, setView] = useState<boolean>(false);
  const [tripData, setTripData] = useState<any[]>([]);
  const [only, setOnly] = React.useState(false);
  const [isDialog, setIsDialog] = useState('');
  const [filterPayload, setFilterPayload] = useState<any>('');
  const [selectedTripRow, setSelectedTripRow] = useState<any | null>(null);
  const [pageNo, setPageNo] = useState(1);
  const [bookingUpdate, IsbookingsUpdate] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const { isLoading: changeLoad } = useAppSelector(state => state.changeDriver);
  const [rowCount, setRowCount] = useState(0);
  const [driverPayload, setDriverPayload] = useState<any | null>(null);
  const [tripPayload, setTripPayload] = useState({ pageNo, pageSize });
  const [scheduledPayload, setScheduledPayload] = useState({
    autoplannerID: scheduleDate
  });
  const openMenu = Boolean(anchorEl);

  const reportData = useAppSelector(state => state.AutoGeneratedTrip);
  const transferDrivers = useAppSelector(state => state.Driverdrop || []);
  const { data: role } = useAppSelector(state => state.auth);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const { data } = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();

  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];
  const dropDriver =
    transferDrivers?.data?.map((driver: any) => ({
      id: driver.driverID,
      label: capitalizeFirstLetter(driver.driverName)
    })) || [];

  let roletype = role?.role;
  const roleAgent = roletype === 'ROLE_AGENT';

  const Driver = () =>
    yup.object().shape({
      driver: yup.string().required('Select Driver Name')
    });

  const {
    control: driverControl,
    handleSubmit: driverHandleSubmit,
    reset
  } = useForm({
    resolver: yupResolver(Driver())
  });

  const handleMenuClick = (row: any) => {
    setSelectedTripRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleUpdateTrip = () => {
    IsbookingsUpdate(true);
    handleMenuClose();
  };

  const handleDriver = (row: any) => {
    setSelectedRow(row);

    const payload = {
      mode: row?.mode,
      date: scheduleDate,
      journeyId: row?.journeyId,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName,
      modifyVehicleDriver: only ? 0 : 1,
      radio: only
    };
    setDriverPayload(payload);
    dispatch(driverDropdownAction(payload));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setOnly(isChecked);
    const payload = {
      ...driverPayload,
      radio: isChecked
    };
    dispatch(driverDropdownAction(payload));
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsDialog('');
    reset();
  };

  const handlePaginationModelChange = (newPaginationModel: PaginationModel) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...tripPayload,
      autoplannerID: scheduleDate,
      tripMode: 'PVT',
      PageNo: newPage,
      PageSize: newPageSize
    };
    setTripPayload(payload);
    dispatch(autoGeneratedTripsAction(payload));
  };

  const columns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuClick(params.row);
                handleUpdateTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },
    {
      field: 'agentName',
      headerName: 'Agent Name',
      minWidth: 150,
      flex: 1
    },

    {
      field: 'guestName',
      headerName: 'Guest Name',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },

    {
      field: 'childCount',
      headerName: 'Child Count',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'adultCount',
      headerName: 'Adult Count',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'refNumber',
      headerName: 'Ref Number',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'source',
      headerName: 'From',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.source}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.destination}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'time',
      headerName: 'Start Time',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      }
    },
    {
      field: 'vehicleNumberView',
      headerName: 'Vehicle Number',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }: any) => row?.vehicleNumber?.toUpperCase()
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 150,
      sortable: false,
      renderCell: (params: any) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '1 00%'
            }}
          >
            {params.row.vehicleNumber !== 'Unassigned' && !roleAgent && (
              <Icon
                icon='ph:user-switch'
                style={{
                  color: '#232323',
                  cursor: 'pointer',
                  fontSize: '25px',
                  marginRight: '10px'
                }}
                className={'activeIcon'}
                onClick={event => {
                  event.stopPropagation();
                  setIsDialog('changeDriver');
                  handleDriver(params.row);
                }}
              />
            )}

            <Typography>{params.value}</Typography>
          </Box>
        );
      },
      flex: 1
    },

    {
      field: 'contactNumber',
      headerName: 'Contact Number',
      minWidth: 150,
      flex: 1
    },

    {
      field: 'seatingCapacity',
      headerName: 'Seating Capacity',
      minWidth: 150,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const onChangeDriverSubmit = async (params: any) => {
    const payload = {
      ...selectedRow,
      ...driverPayload,
      modifyVehicleDriver: only ? 0 : 1,
      driverID: params.driver,
      mode: 'PVT'
    };

    const pageDetails = {
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      id: selectedRow?.id
    };
    const paramss = { ...pageDetails, PageNo: pageNo, PageSize: pageSize };

    const action = await dispatch(getScheduleDriverAction(payload));

    const payloads = {
      ...scheduledPayload,
      autoplannerID: scheduleDate,
      tripMode: 'PVT',
      PageNo: pageNo,
      PageSize: pageSize
    };

    if (action.type === getScheduleDriverAction.fulfilled.type) {
      handleClose();
      setSelectedTripRow(null);
      await dispatch(autoGeneratedTripsAction(payloads));
    }
    handleClose();
    reset();
  };

  useEffect(() => {
    const payload = {
      ...scheduledPayload,
      autoplannerID: scheduleDate,
      tripMode: 'PVT',
      PageNo: pageNo,
      PageSize: pageSize
    };
    dispatch(autoGeneratedTripsAction(payload));
    return () => {
      clearPVTandGRP();
    };
  }, []);

  useEffect(() => {
    if ((reportData as any).data?.customTourOverview?.length > 0) {
      const updatedList = (reportData as any).data.customTourOverview.map(
        (item: any, index: number) => ({
          ...item,
          id: index,
          sno: index + 1,
          time: item?.time,
          vehicleNumberView: capitalize(item?.vehicleNumber ?? '')
        })
      );
      setTripData(updatedList);
    } else {
      setTripData([]);
    }
    // setLoader(reportData?.isLoading);
    // if (reportData?.data?.status)
    // setStatus(reportData?.data?.status);
  }, [reportData]);

  useEffect(() => {
    const filter = {
      autoplannerID: scheduleDate,
      tripMode: 'PVT',
      PageNo: pageNo,
      PageSize: pageSize,
      agentName: agent,
      vehicleNumber: vehicle
    };
    setFilterPayload(filter);
  }, [agent, vehicle]);

  useEffect(() => {
    setPayload({ pageNo: pageNo, pageSize: pageSize });
  }, [pageNo, pageSize]);

  return (
    <Box>
      <CustomBreadcrumbs
        className='tracking-heading'
        itemOne={'Scheduled Tour'}
        itemTwo={'Bookings'}
        itemTwoState={view}
        setView={setView}
      />

      {reportData.isLoading && tripData?.length === 0 ? (
        <Box className='blue-circle-loader'>
          <Box className='blue-circle-spinner'></Box>
        </Box>
      ) : (reportData as any)?.data?.customTourOverview?.length === 0 ||
        (reportData as any)?.data.length === 0 ? (
        <Box className='no-report-img'>
          <Box
            component={'img'}
            src={nodata}
            alt='No Report Found'
            className='no-report-found'
          />
        </Box>
      ) : (
        ''
      )}

      {(reportData as any)?.data?.customTourOverview?.length > 0 && (
        <CustomDataGrid
          rows={tripData}
          columns={columns}
          onRowClick={(event: any, row) => {
            if (!roleAgent) {
              handleUpdateTrip();
              setSelectedTripRow(row);
            }
          }}
          loading={reportData?.isLoading}
          onPaginationModelChange={handlePaginationModelChange}
          //   onSortModelChange={handleSortModelChange}
          type='logistics'
          pageNo={pageNo}
          rowCount={(reportData as any)?.data?.count || 0}
          pageSize={pageSize}
          paginationModel={{
            page: pageNo ? pageNo - 1 : 0,
            pageSize: pageSize || 20
          }}
        />
      )}
      <Dialog
        open={isDialog === 'changeDriver'}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden'
          }
        }}
      >
        <Box
          padding={3}
          width={400}
          component={'form'}
          onSubmit={driverHandleSubmit(onChangeDriverSubmit)}
        >
          <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>
            Change Driver
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '5px',
              marginRight: '10px'
            }}
          >
            <Typography>Changes only applicable for this tour</Typography>
            <Switch
              checked={only}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </Box>
          <CustomSelect
            id='driver'
            control={driverControl}
            name='driver'
            label='Driver Name'
            placeholder='Select Driver Name'
            options={dropDriver}
            loading={transferDrivers.isLoading}
          />
          <Box sx={{ textAlign: 'right', padding: '10px' }}>
            <CustomButton
              category='Cancel'
              className='cancel'
              sx={{ marginRight: '10px' }}
              onClick={() => handleClose()}
            />
            <CustomButton
              category={'Save'}
              className='saveChanges'
              type='submit'
              loading={changeLoad}
            />
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={
          isDialog === 'Delete' || isDialog === 'share' || isDialog === 'DeleteBooking'
        }
      >
        <Box
          sx={{
            textAlign: 'center',
            padding: '5%',
            minWidth: '350px'
          }}
        >
          <Typography>Are You Sure You Want To Delete the Trip</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              paddingTop: '5%',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ marginRight: '12px' }}>
              <CustomButton
                className='saveChanges'
                category='Yes'
                onClick={() => {
                  //  handleDeleteTrip();
                  setIsDialog('');
                }}
              />
            </Box>
            <CustomButton
              className='cancel'
              category='No'
              onClick={() => setIsDialog('')}
            />
          </Box>
        </Box>
      </Dialog>
      {bookingUpdate && (
        <UpdatePVTGRP
          isOpen={bookingUpdate}
          setIsOpen={IsbookingsUpdate}
          selectedTripRow={selectedTripRow}
          selectedRow={selectedRow}
          filterPayload={filterPayload}
          // groupRow={selectedTripRow}
          autoplannerID={scheduleDate}
          pageDetail={{ pageNo: pageNo, pageSize: pageSize }}
          tripMode={'PVT'}
          Agents={agentNames}
        />
      )}
    </Box>
  );
};

export default ScheduledPvt;
